import React from 'react';
import chunk from 'lodash.chunk';
import { createStyleSheet } from '../../../../utils';
import { useStyleSheet } from '../../../../hooks';
import { View } from '../../../View';
import { File } from './File';
export const FileBlock = ({ data, onPress, onDownload, author }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: styles.container }, chunk(data, 2).map((files, index) => (React.createElement(View, { style: [styles.row, index !== 0 ? styles.row__withMargin : {}], key: index }, files.map((file, index) => (React.createElement(File, Object.assign({ key: file.id }, file, { style: index !== 0 ? styles.file__withMargin : {}, onPress: onPress, onDownload: onDownload, author: author })))))))));
};
const getStyles = createStyleSheet(({ size }) => ({
    container: {
        marginVertical: size.B
    },
    row: {
        flexDirection: 'row'
    },
    row__withMargin: {
        marginTop: size.C
    },
    file__withMargin: {
        marginLeft: size.C
    }
}));
//# sourceMappingURL=index.js.map